// extracted by mini-css-extract-plugin
export default {"selector":"nav-dropdown-selector-module__selector--Nr2ep","selected":"nav-dropdown-selector-module__selected--sOgLt"};